// Events
export const RESULT_SET_VALUE = 'covidSelfAssessment/result/setValue/';
export const RISK_LEVEL_SET_VALUE = RESULT_SET_VALUE + 'riskLevel';

export const setRiskLevelValue = value => ({ type: RISK_LEVEL_SET_VALUE, value });
